var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.billingList,
          dense: "",
          loading: _vm.billingGetting,
          "server-items-length": _vm.billingGetCount
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item, expand, isExpanded }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(_vm.getBillingNumber(item.id)))]),
                  _c("td", [_vm._v(_vm._s((item.customer || {}).company))]),
                  _c("td", [
                    _vm._v(_vm._s((item.created_at || "").dateFormat()))
                  ]),
                  _c("td", { staticClass: "success--text" }, [
                    _vm._v(_vm._s(item.completed ? "COMPLETED" : null))
                  ]),
                  _c(
                    "td",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "purple", small: "" },
                          on: {
                            click: function($event) {
                              return _vm.$router.push(
                                `/orders/default/billings/${item.id}/show`
                              )
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-eye")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", small: "", color: "green" },
                          on: {
                            click: function($event) {
                              return _vm.printBill(item)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-cash-multiple")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            small: "",
                            color: "blue-grey darken-2"
                          },
                          on: {
                            click: function($event) {
                              return expand(!isExpanded)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { class: isExpanded ? "is-expanded" : "" },
                            [_vm._v("mdi-chevron-down")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "expanded-item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    { attrs: { colspan: "4" } },
                    [
                      _c("v-simple-table", {
                        attrs: { dense: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function() {
                                return [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [_vm._v("Invoice No.")]),
                                      _c("th", [_vm._v("Particulars")]),
                                      _c("th", [_vm._v("Amount")])
                                    ])
                                  ]),
                                  _c(
                                    "tbody",
                                    _vm._l(item.details, function(detail) {
                                      return _c("tr", { key: detail.id }, [
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.drFormat(detail.invoice_id)
                                            )
                                          )
                                        ]),
                                        _c("td", [
                                          _vm._v(_vm._s(detail.particulars))
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(detail.amount.phpFormat())
                                          )
                                        ])
                                      ])
                                    }),
                                    0
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }